import type { CSSProperties } from 'react';
import { FiCheck as Check } from 'react-icons/fi';
import { ui } from '../constants';
import { resolveAccentColor } from '../utils';
import type { PlanMeta } from '../types';

interface PlanCardProps {
  plan: PlanMeta;
  selected: boolean;
  onSelect: () => void;
}

function PlanCard({ plan, selected, onSelect }: PlanCardProps) {
  return (
    <button
      type="button"
      className={`plan-card rounded-4 bg-white dark__bg-card-dark ${selected ? 'selected' : ''}`}
      style={{ '--plan-color': resolveAccentColor(plan.color) } as CSSProperties}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <span className="card-check rounded-circle">
        {selected ? <Check size={16} strokeWidth={3} /> : null}
      </span>
      <span className="logo-shell rounded-4">
        <img src={plan.logo} alt={`لوگوی ${plan.name}`} />
      </span>
      <span className="plan-copy">
        <strong className="text-1000">{plan.name}</strong>
        <small className="text-secondary fs--2">{plan.subtitle}</small>
      </span>
      <span className="choose-label fs--2">
        {selected ? ui.common.selected : ui.common.selectPlan}
      </span>
    </button>
  );
}

export default PlanCard;
